import {useState, useEffect} from "react";

function checkForIOS() {
    if (navigator.standalone) {
        return false;
    }

    const ua = window.navigator.userAgent;
    const isIPad = !!ua.match(/iPad/i);
    const isIPhone = !!ua.match(/iPhone/i)
    const isIOS = isIPad || isIPhone;
    const isChrome = !!ua.match('CriOS');
    const isSafari = !!ua.match(/Safari/i);

    const desktop = !!navigator.platform.toUpperCase().match(/WIN/i);
    const mac = !!navigator.platform.toUpperCase().match(/MAC/i);

    const isReallySafari = (!isChrome && isSafari);

    const isDesktop = desktop || mac;

    const prompt = isIOS && isReallySafari && !desktop && !mac;

    return {prompt, isDesktop};
}

export default function CheckOS() {
    const [OS, setOS] = useState({});

    useEffect(() => {
        setOS(checkForIOS());
        return;
    }, []);

    return OS;
}